const STORAGE_KEY = 'odus_staff_portal_session';

export function getStaffPortalSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.staffId || !data?.email) return null;
    return data;
  } catch {
    return null;
  }
}

export function setStaffPortalSession({ staffId, email, fullName, role }) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      staffId,
      email,
      fullName: fullName || '',
      role: role || '',
    })
  );
  window.dispatchEvent(new Event('odus-staff-portal-session'));
}

export function clearStaffPortalSession() {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event('odus-staff-portal-session'));
}
